import { defineStore } from 'pinia'
import { ref } from 'vue'
import axios from 'axios'

export const useChatStore = defineStore('chat', () => {
  const messages = ref([])

  function addMessage(msg) {
    messages.value.push(msg)
  }

  function setMessages(msgs) {
    messages.value = msgs
  }

  async function fetchMessages(userId) {
    try {
      const { data } = await axios.get(`/api/chat/${userId}/messages`)
      setMessages(data.messages || [])
      return data.messages
    } catch (e) {
      console.error('Ошибка загрузки сообщений:', e)
      return []
    }
  }

  async function sendMessage(userId, text, pricekodId = null) {
    try {
      const { data } = await axios.post(`/api/chat/${userId}/messages`, {
        message: text,
        pricekod_id: pricekodId,
      })
      addMessage(data.message)
      return data.message
    } catch (e) {
      console.error('Ошибка отправки сообщения:', e)
      return null
    }
  }

  async function fetchAdminChats() {
    const { data } = await axios.get('/api/admin/chats')
    return data.chats || []
  }

  async function fetchAdminMessages(roomId) {
    const { data } = await axios.get(`/api/admin/chats/${roomId}/messages`)
    return data.messages || []
  }

  async function sendAdminMessage(roomId, text) {
    const { data } = await axios.post(`/api/admin/chats/${roomId}/messages`, { message: text })
    return data.message
  }

  async function markRead(roomId) {
    await axios.post(`/api/admin/chats/${roomId}/read`)
  }

  return {
    messages,
    addMessage,
    setMessages,
    fetchMessages,
    sendMessage,
    fetchAdminChats,
    fetchAdminMessages,
    sendAdminMessage,
    markRead,
  }
})